const Inequality02Icon = /*#__PURE__*/ [
  ["path", { d: "M21 20H3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 16H17.1622C19.5429 16 20.7332 16 20.9652 15.3728C21.1971 14.7455 20.2628 14.0531 18.3943 12.6682L6.69853 4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { Inequality02Icon as default };
//# sourceMappingURL=Inequality02Icon.js.map
